import React from 'react'

import { useScrollToTopOnRouteChange } from '@/hooks/useScrollToTopOnRouteChange'

import styles from './Main.module.css'

const Main = ({
	children,
	...props
}: React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLDivElement>,
	HTMLDivElement
>): JSX.Element => {
	const { mainRef } = useScrollToTopOnRouteChange()

	const isCypress = typeof window !== 'undefined' && window.Cypress

	return (
		<main
			className={styles.main}
			id="main-content"
			ref={mainRef}
			data-scroll-container={!isCypress}
			{...props}
		>
			{children}
		</main>
	)
}

export default Main
